import { Badge } from "@/components/ui/badge";
import { CheckCircle2, Clock, MapPin, Users, Award } from "lucide-react";

export default function AboutSection() {
  return (
    <section id="about" className="py-20 sm:py-28 bg-stone-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden h-[400px] lg:h-[520px] bg-pink-100">
              <img
                src="https://customer-assets.emergentagent.com/job_iv-medics-clinic/artifacts/pfkah8vw_1760956373413.jpg"
                alt="IV Medics Healthcare Professional"
                className="w-full h-full object-contain"
                data-testid="about-image"
              />
            </div>
            {/* Stats card */}
            <div className="absolute -bottom-6 right-4 lg:-right-6 bg-white rounded-2xl p-5 shadow-lg border border-stone-100">
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <p className="font-[Outfit] text-2xl font-bold text-green-700">500+</p>
                  <p className="text-xs text-stone-500">Patients Monthly</p>
                </div>
                <div className="text-center">
                  <p className="font-[Outfit] text-2xl font-bold text-green-700">10+</p>
                  <p className="text-xs text-stone-500">Services Offered</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <Badge className="bg-green-100 text-green-800 border-0 mb-4 px-4 py-1.5 rounded-full text-sm font-medium">
              About Us
            </Badge>
            <h2 className="font-[Outfit] text-3xl sm:text-4xl font-bold text-stone-900 tracking-tight mb-6">
              Quality Healthcare, Close to Home
            </h2>
            <p className="text-base md:text-lg text-stone-600 leading-relaxed mb-6">
              IV Medics and Diagnostics Clinic is a trusted healthcare facility located in the heart of Bodija, Ibadan. We are dedicated to providing accessible, affordable, and high-quality medical care to our community.
            </p>
            <p className="text-stone-500 leading-relaxed mb-8">
              From treating common infections to advanced diagnostic services like ultrasound and ECG, surgical procedures, and specialist care — our team of experienced healthcare professionals is here for you and your family.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: CheckCircle2, text: "Comprehensive Care" },
                { icon: Clock, text: "Same-Day Results" },
                { icon: Users, text: "Experienced Medical Team" },
                { icon: Award, text: "Modern Equipment" },
                { icon: MapPin, text: "Convenient Location" },
                { icon: CheckCircle2, text: "142+ Services Available" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 bg-white rounded-xl p-3 border border-stone-100"
                  data-testid={`about-feature-${i}`}
                >
                  <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-4 h-4 text-green-700" />
                  </div>
                  <span className="text-sm font-medium text-stone-700">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
